;(() => {
	var __webpack_exports__ = {}
	Shopify.theme.jsMegaMenu = {
		init: function ($section) {
			const sectionData = Shopify.theme.getSectionData($section) || {}

			// Global state (shared across every mega-menu section instance).
			// This prevents multiple mega menus being opened simultaneously when different sections
			// bind their own handlers (click/hover) at different times.
			Shopify.theme._megaMenuState = Shopify.theme._megaMenuState || {
				activeHandle: null,
				isTransitioning: false,
				unlockTimer: null,
			}
			const globalState = Shopify.theme._megaMenuState

			const parentLink = sectionData.parent_link
			const sectionId = sectionData.section_id
			const sectionNamespace = `.jsMegaMenu_${sectionId}`
			const $megaMenu = $section.find(".mega-menu__" + sectionId)
			const handle = (parentLink || "")
				.toString()
				.toLowerCase()
				.replace(/\s+/g, "-")

			$(`.mega-menu__section[data-parent-handle="${handle}"]`).remove()

			/* ============= MOBILE CLONE ============= */
			const isMobile = window.matchMedia("(max-width: 798px)").matches
			const $parentMobileElement = $(
				`[data-mobile-menu-navlink-handle="${handle}"]`,
			)

			if (isMobile) {
				return
			} else {
				if ($parentMobileElement.length) {
					if ($parentMobileElement.find(".has-no-submenu").length) {
						$parentMobileElement
							.find("a.mobile-menu__item")
							.addClass("mobile-menu-link")
						$parentMobileElement
							.find("a")
							.after('<span class="close-dropdown"></span>')
						$parentMobileElement
							.find(".submenu__label")
							.after(
								'<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>',
							)
						$parentMobileElement
							.find("[data-mobile-menu-has-toggle]")
							.attr("data-mobile-menu-has-toggle", true)
						$megaMenu
							.clone()
							.appendTo(
								$parentMobileElement.find(".has-mega-menu"),
							)
					} else {
						let $list = $parentMobileElement.find(
							"[data-mobile-submenu-first-level-list]",
						)
						$list
							.empty()
							.addClass("has-mega-menu")
							.removeClass("has-dropdown")
						const $mobileMega = $megaMenu.clone()

						$mobileMega
							.addClass("mega-menu--mobile")
							.removeAttr("style")
						$megaMenu.clone().appendTo($list)
					}
				}
			}

			const $header = $("#header")
			if (!$header.length || !$megaMenu.length) return

			/* ============= DESKTOP CLONE ============= */
			const $clone = $megaMenu.clone()
			if (!$clone.length) return

			$clone.addClass("mega-menu__section--clone")
			$clone.attr("aria-hidden", "true")
			$clone.attr("data-parent-handle", handle)
			$header.after($clone)

			$clone.css({
				display: "block",
				position: "fixed",
				left: 0,
				width: "100%",
				zIndex: 9999,
			})

			function updateMegaMenuPosition() {
				const $announcement = $(
					".announcement-bar:visible, .announcement:visible, .announcement-sticky-wrapper:visible",
				)
				const $header = $("#header")

				let aHeight = 0
				let hHeight = 0

				if ($announcement.length) {
					$announcement.each(function () {
						aHeight += $(this).outerHeight() || 0
					})
				}

				if ($header.length) {
					hHeight = $header.outerHeight() || 0
				}

				const scrollY = window.scrollY

				let top = hHeight

				if ($announcement.length && scrollY < 10) {
					top = aHeight + hHeight
				}

				$(`.mega-menu__section[data-parent-handle="${handle}"]`).css(
					"top",
					`${top}px`,
				)
			}

			updateMegaMenuPosition()
			$(window).off(
				`scroll.megaMenuReposition${sectionNamespace} resize.megaMenuReposition${sectionNamespace}`,
			)
			$(window).on(
				`scroll.megaMenuReposition${sectionNamespace} resize.megaMenuReposition${sectionNamespace}`,
				updateMegaMenuPosition,
			)

			/* ============= NAV HANDLERS ============= */
			const $parentElement = $(`[data-navlink-handle="${handle}"]`)
			const $parentElementLink = $parentElement.children(".header__link")

			if (
				$parentElement.length &&
				($parentElement.hasClass("header__item") ||
					$parentElement.hasClass("vertical-header__first-level"))
			) {
				// Ocultar dropdown clásico
				$parentElement
					.find(".navbar-dropdown")
					.addClass("is-invisible is-hidden")

				// 🔑 ESTA LÍNEA DEVUELVE LA FLECHA
				$parentElementLink.removeClass("is-arrowless")

				// Marca como mega menú
				$parentElement.addClass("has-mega-menu")
			}

			const canHover =
				window.matchMedia &&
				window.matchMedia("(hover: hover) and (pointer: fine)").matches
			const themeOpenOnHover = $(".dropdown-click--false").length > 0
			const hasSectionOpenOnHover = Object.prototype.hasOwnProperty.call(
				sectionData,
				"open_on_hover",
			)
			const sectionOpenOnHover = hasSectionOpenOnHover
				? sectionData.open_on_hover === true
				: null
			const openOnHover =
				(sectionOpenOnHover === null
					? themeOpenOnHover
					: sectionOpenOnHover) && canHover

			const normalizeHandle = (value) =>
				(value || "").toString().toLowerCase().replace(/\s+/g, "-")

			const ANIMATION_MS = 300

			function lockTransitions() {
				globalState.isTransitioning = true
				if (globalState.unlockTimer)
					clearTimeout(globalState.unlockTimer)
				globalState.unlockTimer = setTimeout(() => {
					globalState.isTransitioning = false
					globalState.unlockTimer = null
				}, ANIMATION_MS)
			}

			function resetAllMenuStates() {
				$(".mega-menu__section--clone.is-active")
					.removeClass("is-active")
					.attr("aria-hidden", "true")
				$(".has-mega-menu")
					.removeClass("is-opened")
					.attr("aria-expanded", "false")
				globalState.activeHandle = null
			}

			function initMegaMenuCarousel($scope) {
				if (!window.Flickity) return
				$scope
					.find(".mega-menu__carousel[data-flickity]")
					.each(function () {
						const el = this
						if (el.classList.contains("flickity-enabled")) return

						let options = {}
						const optionsAttr = el.getAttribute("data-flickity")
						if (optionsAttr) {
							try {
								options = JSON.parse(optionsAttr)
							} catch (e) {
								options = {}
							}
						}

						new window.Flickity(el, options)
					})
			}

			function resizeMegaMenuCarousel($scope) {
				if (!window.Flickity) return
				$scope
					.find(".mega-menu__carousel.flickity-enabled")
					.each(function () {
						const flkty = window.Flickity.data(this)
						if (!flkty) return
						if (typeof flkty.reloadCells === "function")
							flkty.reloadCells()
						if (typeof flkty.resize === "function") flkty.resize()
					})
			}

			function updateMegaMenuCarouselFade(el) {
				if (!el) return

				const isFlickity =
					el.classList.contains("flickity-enabled") &&
					typeof window.Flickity !== "undefined"

				if (isFlickity) {
					const flkty = window.Flickity.data(el)
					const viewport = el.querySelector(".flickity-viewport")
					const slider = el.querySelector(".flickity-slider")
					const visibleWidth = viewport
						? viewport.clientWidth
						: el.clientWidth
					const contentWidth = slider
						? slider.scrollWidth
						: el.scrollWidth

					const isOverflowing = contentWidth > visibleWidth + 1
					const prevButtonEl =
						flkty && flkty.prevButton
							? flkty.prevButton.element
							: null
					const nextButtonEl =
						flkty && flkty.nextButton
							? flkty.nextButton.element
							: null

					if (!isOverflowing || !flkty) {
						el.classList.remove("is-fade-left", "is-fade-right")
						return
					}

					const prevDisabled = prevButtonEl
						? prevButtonEl.disabled
						: true
					const nextDisabled = nextButtonEl
						? nextButtonEl.disabled
						: true

					el.classList.toggle("is-fade-left", !prevDisabled)
					el.classList.toggle("is-fade-right", !nextDisabled)

					return
				}

				const maxScrollLeft = el.scrollWidth - el.clientWidth
				const isOverflowing = el.scrollWidth > el.clientWidth + 1
				if (!isOverflowing) {
					el.classList.remove("is-fade-left", "is-fade-right")
					return
				}

				el.classList.toggle("is-fade-left", el.scrollLeft > 1)
				el.classList.toggle(
					"is-fade-right",
					el.scrollLeft < maxScrollLeft - 1,
				)
			}

			function initMegaMenuCarouselFade($scope) {
				$scope.find(".mega-menu__carousel").each(function () {
					const el = this
					if (el.dataset.megaMenuFadeBound === "true") {
						updateMegaMenuCarouselFade(el)
						return
					}

					el.dataset.megaMenuFadeBound = "true"

					const onUpdate = () => updateMegaMenuCarouselFade(el)

					if (
						el.classList.contains("flickity-enabled") &&
						typeof window.Flickity !== "undefined"
					) {
						const flkty = window.Flickity.data(el)
						if (flkty) {
							flkty.on("scroll", onUpdate)
							flkty.on("select", onUpdate)
							flkty.on("settle", onUpdate)
							flkty.on("resize", onUpdate)
						}
					} else {
						el.addEventListener("scroll", onUpdate, {
							passive: true,
						})
						window.addEventListener("resize", onUpdate, {
							passive: true,
						})
					}

					onUpdate()
				})
			}

			function openMegaAnimated(handleToOpen) {
				const normalized = normalizeHandle(handleToOpen)
				const $target = $(
					`.mega-menu__section--clone[data-parent-handle="${normalized}"]`,
				)
				if (!$target.length) return

				$target.attr("aria-hidden", "false").addClass("is-active")
				$(`[data-navlink-handle="${normalized}"]`)
					.filter(".has-mega-menu")
					.addClass("is-opened")
					.attr("aria-expanded", "true")

				globalState.activeHandle = normalized
				updateMegaMenuPosition()
				initMegaMenuCarousel($target)
				resizeMegaMenuCarousel($target)
				initMegaMenuCarouselFade($target)
			}

			function closeAllMegaAnimated() {
				lockTransitions()
				resetAllMenuStates()
			}

			function requestOpen(handleToOpen) {
				const normalized = normalizeHandle(handleToOpen)
				if (!normalized) return
				if (globalState.isTransitioning) return
				if (globalState.activeHandle === normalized) return

				lockTransitions()
				resetAllMenuStates()
				openMegaAnimated(normalized)
			}

			function requestToggle(handleToToggle) {
				const normalized = normalizeHandle(handleToToggle)
				if (!normalized) return
				if (globalState.isTransitioning) return

				const isOpen = globalState.activeHandle === normalized
				if (isOpen) {
					closeAllMegaAnimated()
					return
				}

				lockTransitions()
				resetAllMenuStates()
				openMegaAnimated(normalized)
			}

			let hideTimer = null
			const clearHideTimer = () => {
				if (hideTimer) {
					clearTimeout(hideTimer)
					hideTimer = null
				}
			}
			const scheduleHideAll = () => {
				clearHideTimer()
				hideTimer = setTimeout(() => {
					closeAllMegaAnimated()
				}, 120)
			}

			const $clickTarget = $parentElementLink.length
				? $parentElementLink
				: $parentElement.children(".vertical-header__first-level-link")
			$parentElement.attr("aria-haspopup", "true")

			$parentElement.off(sectionNamespace)
			$clone.off(sectionNamespace)
			$(document).off(sectionNamespace)

			if (openOnHover) {
				$parentElement
					.removeAttr("data-mega-menu-interaction")
					.removeClass("is-opened")
					.attr("aria-expanded", "false")

				$parentElement.on(`mouseenter${sectionNamespace}`, () => {
					clearHideTimer()
					requestOpen(handle)
				})
				$parentElement.on(
					`mouseleave${sectionNamespace}`,
					scheduleHideAll,
				)

				$clone.on(`mouseenter${sectionNamespace}`, clearHideTimer)
				$clone.on(`mouseleave${sectionNamespace}`, scheduleHideAll)
			} else {
				$parentElement
					.attr("data-mega-menu-interaction", "click")
					.attr("aria-expanded", "false")

				const toggle = (e) => {
					if (e && typeof e.stopImmediatePropagation === "function")
						e.stopImmediatePropagation()
					if (e && typeof e.stopPropagation === "function")
						e.stopPropagation()

					if (
						!$(
							`.mega-menu__section[data-parent-handle="${handle}"]`,
						).length
					)
						return

					e.preventDefault()
					requestToggle(handle)
				}

				$clickTarget.on(`click${sectionNamespace}`, toggle)
				$clickTarget.on(`keydown${sectionNamespace}`, (e) => {
					if (e.which === 13 || e.which === 32) {
						e.preventDefault()
						toggle(e)
					}
				})

				$clone.on(`click${sectionNamespace}`, (e) =>
					e.stopPropagation(),
				)
				$(document).on(`click${sectionNamespace}`, (e) => {
					if ($(e.target).closest($parentElement).length) return
					if ($(e.target).closest($clone).length) return
					closeAllMegaAnimated()
				})
			}
		},

		unload: function ($section) {
			const sectionData = Shopify.theme.getSectionData($section) || {}
			const sectionId = sectionData.section_id
			const sectionNamespace = `.jsMegaMenu_${sectionId}`
			const parentLink =
				sectionData.parent_link ||
				$section.find(".mega-menu").data("parent-link")
			const handle = (parentLink || "")
				.toString()
				.toLowerCase()
				.replace(/\s+/g, "-")

			$(window).off(
				`scroll.megaMenuReposition${sectionNamespace} resize.megaMenuReposition${sectionNamespace}`,
			)
			$(document).off(sectionNamespace)

			const $parentElement = $(`[data-navlink-handle="${handle}"]`)
			$parentElement
				.off(sectionNamespace)
				.removeAttr("data-mega-menu-interaction")
				.removeClass("is-opened")

			if (
				Shopify.theme._megaMenuState &&
				Shopify.theme._megaMenuState.activeHandle === handle
			) {
				Shopify.theme._megaMenuState.activeHandle = null
			}

			$(`.mega-menu__section[data-parent-handle="${handle}"]`)
				.off(sectionNamespace)
				.remove()
		},
	}
})()
